import { style } from '@vanilla-extract/css';

export const postCommentsFeedElement = style({});

export const commentAuthorBorder = style({
  border: 'solid 1px var(--comments-feed-author-border-color)',
});

export const commentText = style({
  fontSize: 'var(--comments-feed-font-size)',
  fontWeight: 'var(--comments-feed-font-weight)',
  color: 'var(--comments-feed-comment-text-color)',
});

export const commenterText = style({
  fontSize: 'var(--comments-feed-font-size)',
  fontWeight: 'var(--comments-feed-font-weight)',
  color: 'var(--comments-feed-commenter-text-color)',
});

export const timestampText = style({
  fontSize: 'var(--comments-feed-font-size)',
  fontWeight: 'var(--comments-feed-font-weight)',
  color: 'var(--comments-feed-timestamp-text-color)',
});

export const actionText = style({
  fontSize: 'var(--comments-feed-font-size)',
  fontWeight: 'var(--comments-feed-font-weight)',
  color: 'var(--comments-feed-action-text-color)',
});

export const moderatorText = style({
  fontSize: 'var(--comments-feed-font-size)',
  fontWeight: 'var(--comments-feed-font-weight)',
  color: 'var(--comments-feed-moderator-text-color)',
});

export const authorBadge = style({
  color: 'var(--comments-feed-moderator-text-color)',
  backgroundColor: 'color-mix(in srgb, var(--comments-feed-moderator-text-color) 10%, transparent)',
  borderRadius: '4px',
  paddingLeft: '4px',
  paddingRight: '4px',
  paddingTop: '2px',
  paddingBottom: '2px',
  fontSize: '12px',
  fontWeight: '500',
  lineHeight: '1',
});
